import { render } from "./AppHeader.vue?vue&type=template&id=8c0413d4"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=8c0413d4&lang=css"
script.render = render

export default script